import { Observable } from "rxjs/Observable"

import { idify } from "../../reducers/paging/paging-reducer-utils"
import { mapRequestError } from "./epic-utils"

import { unauthenticated } from "../../actions/authentication-actions"

export const updateMappingConceptEpic = (
    type,
    presentationAccessor,
    mappingPreviewRequestActionCreator,
    fingerprintPreviewRequestActionCreator
) => (action$, { getState }) =>
    action$.ofType(type).mergeMap(() => {
        const { activeId, mappingToBeAdded } = getState().presentation[
            presentationAccessor
        ]
        let actions = []
        if (mappingToBeAdded.positive.length) {
            if (mappingPreviewRequestActionCreator) {
                const mappingPreviewRequestAction = mappingPreviewRequestActionCreator(
                    activeId,
                    mappingToBeAdded
                )
                actions = [...actions, mappingPreviewRequestAction]
            }
        }
        if (fingerprintPreviewRequestActionCreator) {
            const fingerprintRequestAction = fingerprintPreviewRequestActionCreator()
            actions = [...actions, fingerprintRequestAction]
        }
        return Observable.of(...actions)
    })

export const removeMappingEpic = (
    type,
    presentationAccessor,
    mappingDeletePreviewRequest,
    fingerprintPreviewRequestActionCreator
) => (action$, { getState }) =>
    action$.ofType(type).mergeMap(({ mapping }) => {
        const { activeId } = getState().presentation[presentationAccessor]

        let actions = []
        if (mapping.id && mappingDeletePreviewRequest) {
            const mappingPreviewAction = mappingDeletePreviewRequest(
                activeId,
                mapping.id
            )
            actions = [...actions, mappingPreviewAction]
        }
        if (fingerprintPreviewRequestActionCreator) {
            const fingerprintRequestAction = fingerprintPreviewRequestActionCreator()
            actions = [...actions, fingerprintRequestAction]
        }
        return Observable.of(...actions)
    })

export const requestMappingPreviewEpic = (
    [mappingPreviewRequestType, mappingDeletePreviewRequestType],
    postPreviewMappingAPI,
    deletePreviewMappingAPI,
    mappingPreviewResponseActionCreator,
    mappingPreviewErrorResponseActionCreator
) => (action$, { getState }) =>
    action$
        .ofType(mappingPreviewRequestType, mappingDeletePreviewRequestType)
        .switchMap(({ type, id, previewMapping }) => {
            const { token } = getState().authentication
            let mapping = previewMapping
            if (type === mappingPreviewRequestType) {
                mapping = {
                    positive: idify(previewMapping.positive),
                }
            }
            const api =
                type === mappingPreviewRequestType
                    ? postPreviewMappingAPI
                    : deletePreviewMappingAPI
            return api(token, id, mapping)
                .map((response) =>
                    mappingPreviewResponseActionCreator(response)
                )
                .catch((error) =>
                    Observable.of(
                        mapRequestError(
                            error,
                            unauthenticated,
                            mappingPreviewErrorResponseActionCreator,
                            id,
                            previewMapping
                        )
                    )
                )
        })
